import { EventEmitter } from 'events';
var formStateEventEmitter = new EventEmitter();
var formStateCache = {};
export var FORM_STATE_CHANGE_EVENT_NAME = 'SINOUI_FORM_STATE_CHANGE';
/**
 * 监听表单状态变化
 *
 * @private
 * @export
 * @param {string} formName 表单名称
 * @param {Function} listener 监听器
 */
export function listen(formName, 
// tslint:disable-next-line:no-any
listener) {
    formStateEventEmitter.addListener(formName + "_" + FORM_STATE_CHANGE_EVENT_NAME, listener);
    if (formStateCache[formName]) {
        listener(formStateCache[formName]);
    }
}
/**
 * 取消表单状态监听
 *
 * @export
 * @param {string} formName 表单名称
 * @param {Function} listener 监听器
 */
export function un(formName, 
// tslint:disable-next-line:no-any
listener) {
    formStateEventEmitter.removeListener(formName + "_" + FORM_STATE_CHANGE_EVENT_NAME, listener);
}
/**
 * 发布表单状态变更
 *
 * @export
 * @param {string} formName 表单名称
 * @param {any} state 表单状态
 */
// tslint:disable-next-line:no-any
export function emit(formName, state) {
    formStateCache[formName] = state;
    formStateEventEmitter.emit(formName + "_" + FORM_STATE_CHANGE_EVENT_NAME, state);
}
export function unregisterForm(formName) {
    delete formStateCache[formName];
}
//# sourceMappingURL=FormStateStack.js.map